import { FixtureCompetitionTrckGrpLayout } from '#src/layouts/FixtureCompetitionTrckGrpLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

export const TrckGrpLayout = () => {
  return <FixtureCompetitionTrckGrpLayout<LayoutParams> arena />;
};

export default TrckGrpLayout;
